module.exports = __webpack_public_path__ + "static/media/CYRKULACJA-off.5f752876.svg";